module.exports = __webpack_public_path__ + "img/figma.fe22ea94.png";